import { dayjsUTC } from "@/helpers/dateHelper"
import IParser from "@/types/IParser"
import ParseError from "@/types/ParseError"
import { WarrantsDcaQueue } from "@/models/admin/warrantsDcaQueue/warrantsDcaQueue"
import { IWarrantsDcaQueue } from "@/models/admin/warrantsDcaQueue/warrantsDcaQueue.types"

/**
 * A single `warrants_dca_queue` row as returned by Hasura. Mirrors the
 * generated `Financials_Warrants_Dca_Queue` row; kept as a narrow type so the
 * parser only depends on the columns it actually reads.
 */
export type WarrantsDcaQueueRaw = {
  id: number
  account_number: string
  created_at: string
  processed_at?: string | null
  deleted_at?: string | null
}

export const WarrantsDcaQueueParser: IParser<
  IWarrantsDcaQueue,
  WarrantsDcaQueueRaw
> = {
  toDomain(data) {
    try {
      // Hasura `timestamp` columns are naive UTC, so parse them as UTC and
      // convert to local time for display.
      return new WarrantsDcaQueue(
        data.id,
        data.account_number,
        dayjsUTC(data.created_at),
        data.processed_at ? dayjsUTC(data.processed_at) : null,
        data.deleted_at ? dayjsUTC(data.deleted_at) : null,
      )
    } catch (error) {
      throw new ParseError(error)
    }
  },
}
